import React from 'react';

import ProcessManagementSearchInput from 'processes/ProcessManagementSearchInput';
import {Filter, MultiValueFilter, Operator} from 'search/SearchConstants';

import {BaseFilterFormProps, FilterStyle} from './base/FilterFormConstants';
import {ItemSearchMultiValueFilterForm} from './ItemSearchFilterForm';

interface ProcessFilterFormProps extends BaseFilterFormProps {
  filter: MultiValueFilter;
  filterStyle: FilterStyle;
  onChangeFilter: (filter: MultiValueFilter) => void;
  onEnter?: () => void;
  onRemove?: () => void;
  operators: Array<Operator>;
}

export default function getProcessManagementFilterForm(
  selectedType: string,
  extraFilters?: Array<Filter>
): (props: ProcessFilterFormProps) => JSX.Element {
  return (props: ProcessFilterFormProps): JSX.Element => (
    <ItemSearchMultiValueFilterForm
      {...props}
      itemSearchInputClass={ProcessManagementSearchInput}
      itemSearchInputExtraProps={{selectedType, extraFilters, shouldAllowMultiple: true}}
    />
  );
}
